export interface Design {
  Error: boolean;
  Message: string;
  Designs?: DesignsEntity[] |  null;
  system:any;
}
export interface DesignsEntity {
  id?: number;
  name?: string;
  designcomplete?: boolean;
  completesystems?: boolean;
  cfa?: number;
  wa?: number;
  noocupants?: string;
  active?:boolean
}
export class DesignFormModel {
  customer_id?: number;
  customer_id2?: string;
  contact_id2?: string;
  contact_id?: number;
  ventmeet622?: string;
  designcomplete?: boolean;
  venair622?: string;
  hvac_dsn_descrpt?: string;
  heatlossmtd?: string;
  indoortemp?: string;
  outdoor1_?: string;
  outdoor99_?: string;
  noocupants?: string;
  outdoortemplocation?: string;
  cfa?: number;
  wa?: string;
  shgc?: number;
  summerinfiltration?: string;
  winterinfiltration?: string;
  mechanicalvent?: string;
  hvac_design_id?:string;
}

export interface DesignsModel {
  hvac_design_id?: number;
  hvac_dsn_descrpt?: string;
  customer_id?: number;
  contact_id?: number;
  designername?: string;
  companyname?: string;
  ventmeet622?: string;
  date?: null;
  venair622?: string;
  heatlossmtd?: string;
  indoortemp?: string;
  outdoortemplocation?: string;
  outdoor1_?: string;
  outdoor99_?: string;
  noocupants?: string;
  cfa?: string;
  wa?: string;
  shgc?: string;
  summerinfiltration?: string;
  winterinfiltration?: string;
  mechanicalvent?: string;
  completesystems?: boolean;

}


export interface SystemDesign {
  Error: boolean;
  Message: string;
  Designs?: DesignsModel |  null;
}



export interface DesignSystem {
  Error: boolean;
  Message: string;
  system?: (SystemEntity)[] | null;
}
export interface SystemEntity {
  selection_id: number;
  hvac_design_id: number;
  equipment_id: string;
  designairflowcool: string;
  designstaticp: string;
  areaserved?: null;
  tempoccload?: null;
  mansmethod?: null;
  cfm_freshair?: null;
  dehurqd?: null;
  coolcapappropriate?: null;
  heatcapappropriate?: null;
  selectioncomplete?: null;
  ratercompid?: null;
  equiptype?: null;
  designairflowheat: string;
  hvacfanspdheat: string;
  hvacfanspdcool: string;
  venairflo0: string;
  runtimecyc: string;
  cycletime?: null;
  systtypesp?: null;
  contlocspe: string;
  fanratedsones: string;
  fanreducevnt: string;
  bathroomfanses: string;
  inletpullsoutdr: string;
  inletlocation: string;
  opwointrvntn: string;
  ventoverride: string;
  useintakeright: string;
  section1?: null;
  section2?: null;
  section3?: null;
  coolingsizinglimit: string;
  coolsizepctlimit?: null;
  heatsizinglimit: string;
  heatsizepctlimit?: null;
  heatsizingpct?: null;
  coolsizingpct: string;
  ventna?: null;
  dessheatgainn?: null;
  dessheatgainne?: null;
  dessheatgains?: null;
  dessheatgainse?: null;
  dessheatgainnw?: null;
  dessheatgainsw?: null;
  dessheatgainw?: null;
  dessheatgaine?: null;
  destotlheatgainn?: null;
  destotlheatgainne?: null;
  destotlheatgainnw?: null;
  destotlheatgains?: null;
  destotlheatgainse?: null;
  destotlheatgainsw?: null;
  destotlheatgaine?: null;
  destotlheatgainw?: null;
  deslheatgain?: null;
  maxtotal: string;
  loadsensheatgain?: null;
  desttotlheatloss: string;
  manuald: string;
  difference?: null;
  name: string;
  radio1: string;
  specifiedsystype: string;
  specifiedcontrollloca?: null;
  specifiedcontrl?: null;
  nooutdoorair?: null;
  ventairrate: string;
  ventauirflowrate?: null;
  runtimepercycles?: null;
  cycletimes: string;
  maxheatgain: string;
  systemcomplete: string;
  compdoldrh?: null;
  customer_id: string;
  plan_id?: null;
  contact_id: string;
  hvacdesigndate?: null;
  hvac_dsn_descrpt: string;
  ventmeet622: string;
  ventdocattached?: null;
  heatlossmtd: string;
  ductdsmtd?: null;
  outdoortemplocation: string;
  outdoor1_: string;
  outdoor99_: string;
  orientation?: null;
  cfa: string;
  wa: string;
  shgc: string;
  summerinfiltration: string;
  winterinfiltration: string;
  dessheatgain?: null;
  destotlheatgain?: null;
  destotalheatloss?: null;
  loadfile?: null;
  loadcomplete?: null;
  reasonforloc?: null;
  paperworklink?: null;
  loadfinished?: null;
  venairflowereq?: null;
  designcomplete: boolean;
  indoortemp: string;
  noreturnintake?: null;
  noocupants: string;
  maxminusmin?: null;
  airinletna?: null;
  section1acomplete?: null;
  section1bcomplete?: null;
  section2complete?: null;
  section3complete?: null;
  mechanicalvent: string;
  maxloss?: null;
  minloss?: null;
  completesystems: boolean;
  forcefieldrules?: null;
  venair622: string;
}


export interface Room {
  Error: boolean;
  Message: string;
  room?: (RoomEntity)[] | null;
}
export class RoomEntity {
  name: string;
  room_id: number;
  selection_id: string;
  room_descr: string;
  dsh_heat_flow: string | string;
  hvac_design_id: number | string;
}


